import { render } from "./AboutUsDispoDifferenceCMS.vue?vue&type=template&id=76bb8817&scoped=true"
import script from "../js/about-us-dispo-difference-cms.js?vue&type=script&lang=js"
export * from "../js/about-us-dispo-difference-cms.js?vue&type=script&lang=js"

import "./AboutUsDispoDifferenceCMS.vue?vue&type=style&index=0&id=76bb8817&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bb8817"]])

export default __exports__